/**
 * @description Hook utilizado para manipular os exames de identificação necropapiloscópica
 * @author Diego Sabino Amorim de Araújo
 * @file useExameIdentificacaoNecropapiloscopicaService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { setIdExameRealizado } from 'actions'
import { useDispatch } from 'react-redux'
import { useFetch } from './useFetch'

export const useExameIdentificacaoNecropapiloscopicaService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const realizarIdentificacaoNecropapiloscipica = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.post(`/examesRealizados/exameNecropapiloscopico/`, dados)
      dispatch(setIdExameRealizado(response.data.exameRealizado.id))
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarExameNecropapiloscopicoDetalhadoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameNecropapiloscopico/detalhado/${id}`)
      return response.data.exameNecropapiloscopico
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarAnaliseNecropapiloscopicaDeVestigioEmExameAsync = async (idVestigio, idExame, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameNecropapiloscopico/analiseNecropapiloscopica/deExame/examinador/${idVestigio}/${idExame}`)
      return response.data.analiseNecropapiloscopica
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarExameNecropapiloscopico = async (id, values, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`/exameNecropapiloscopico/${id}`, values)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarAnaliseNecropapiloscopica = async (values, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)

      await fetch.postOpen(`/exameNecropapiloscopico/analiseNecropapiloscopica`, values)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarAnaliseNecropapiloscopica = async (id, values, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`/exameNecropapiloscopico/analiseNecropapiloscopica/${id}`, values)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const alterarDadosCadaverDeImpressaoAnalisada = async (idExame, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`/exameNecropapiloscopico/alterarDadosCadaver/${idExame}`)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    realizarIdentificacaoNecropapiloscipica,
    listarExameNecropapiloscopicoDetalhadoAsync,
    listarAnaliseNecropapiloscopicaDeVestigioEmExameAsync,
    editarExameNecropapiloscopico,
    cadastrarAnaliseNecropapiloscopica,
    editarAnaliseNecropapiloscopica,
    alterarDadosCadaverDeImpressaoAnalisada,
  }
}
